import { mockDataAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-export-code';
const CONV_ID = 'conv-4';
const MD_BLOCK_ID = 'blk-export-md';
const QS_BLOCK_ID = 'blk-export-qs';
const CODE_BLOCK_ID = 'blk-export-code';
const CALLOUT_BLOCK_ID = 'blk-export-callout';
const FILE_BLOCK_ID = 'blk-export-file';
const markdownText = 'I ran a query across your inspection database and exported the results. ' +
    'Here is the SQL query I used and the downloadable report:';
const querySourceBlock = {
    type: 'query_source',
    block_id: QS_BLOCK_ID,
    block_index: 1,
    source_type: 'sql',
    tables_used: ['inspections', 'buildings', 'deficiencies'],
    execution_time_ms: 234,
    row_count: 128
};
const codeBlock = {
    type: 'code',
    block_id: CODE_BLOCK_ID,
    block_index: 2,
    language: 'sql',
    title: 'Generated Query',
    content: 'SELECT b.name AS building,\n' +
        '       COUNT(d.id) AS deficiency_count,\n' +
        '       MAX(i.completed_at) AS last_inspection\n' +
        'FROM buildings b\n' +
        'JOIN inspections i ON i.building_id = b.id\n' +
        'JOIN deficiencies d ON d.inspection_id = i.id\n' +
        "WHERE i.completed_at >= '2025-01-01'\n" +
        'GROUP BY b.name\n' +
        'ORDER BY deficiency_count DESC;',
    copyable: true
};
const calloutBlock = {
    type: 'callout',
    block_id: CALLOUT_BLOCK_ID,
    block_index: 3,
    variant: 'info',
    title: 'Large Dataset',
    content: 'Results limited to 128 rows. Use the exported file for the full dataset.',
    dismissible: true
};
const fileDownloadBlock = {
    type: 'file_download',
    block_id: FILE_BLOCK_ID,
    block_index: 4,
    file_id: 'file-export-001',
    file_name: 'deficiency_report_2025.csv',
    file_type: 'csv',
    mime_type: 'text/csv',
    download_url: '/api/v1/exports/file-export-001',
    download_url_expires_at: '2025-03-01T00:00:00Z',
    file_size_bytes: 24576,
    file_size_display: '24 KB',
    preview_available: true,
    preview_rows: 10,
    total_rows: 128,
    generation_context: 'Exported from deficiency count query'
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockDataAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText, 18, 60),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(querySourceBlock, 200),
    makeBlockComplete(codeBlock, 300),
    makeBlockComplete(calloutBlock, 200),
    makeBlockComplete(fileDownloadBlock, 300),
    makeStreamEnd(RESPONSE_ID, 5, mockDataAgent)
];
export const scenario = {
    name: 'Data Assistant — Export with Code',
    description: 'Data export flow showcasing QuerySource, Code block with SQL, an info Callout, and FileDownload.',
    conversations: mockConversations,
    userMessage: 'Export all deficiency counts by building for 2025',
    agentIdentity: mockDataAgent,
    sseSequence
};
